import PageHero from "@/components/jf/PageHero";
import Contact from "@/components/jf/Contact";

export default function BookPage({ selectedProduct }) {
  return (
    <main>
      <PageHero
        kicker="Online Booking"
        title={<>Your furniture is <em className="text-brass-soft font-light">one form away.</em></>}
        accent="→"
      >
        <p className="mt-8 max-w-xl text-ivory/70 font-light leading-relaxed text-base md:text-lg">
          No advance payment. Book online and our team calls you within 24 hours to confirm
          materials, pricing and delivery.
        </p>
      </PageHero>
      <Contact selectedProduct={selectedProduct} />
    </main>
  );
}
